import axios from "axios";
import { failAlert, successAlert } from "./helper";

const {
  GROUPS_START,
  GET_GROUPS_SUCCESS,
  GROUPS_FAIL,
  GROUPS_DELETE_SUCCESS,
  ADD_NEW_GROUP_SUCCESS,
  EDIT_GROUP,
  SAVE_GROUP_FILTER,
  SELECTED_GROUP,
  EMPTY_GROUPS,
} = require("./constants");

// Add new Group
export const AddNewGroup = (groupData, groupToRender, token) => async (dispatch) => {
  try {
    dispatch({ type: GROUPS_START });
    const {
      data: { group },
    } = await axios.post("/api/v1/groups/", groupData, {
      headers: {
        Authorization: token,
      },
    });
    dispatch({
      type: ADD_NEW_GROUP_SUCCESS,
      data: { ...groupData, _id: group._id, avatar_color: group.avatar_color },
      groupToRender: { ...groupToRender, _id: group._id, avatar_color: group.avatar_color },
    });
    successAlert("created");
  } catch (error) {
    dispatch({
      type: GROUPS_FAIL,
      payload: { type: "added", message: error.message },
    });
  }
};

// Edit Group
export const editGroup = (groupData, groupToRender, token, stopAlert) => async (dispatch) => {
  try {
    dispatch({ type: GROUPS_START });
    await axios.put(`/api/v1/groups/${groupData._id}`, groupData, {
      headers: {
        Authorization: token,
      },
    });
    dispatch({ type: EDIT_GROUP, groupToRender });
    !stopAlert && successAlert("updated");
  } catch (error) {
    dispatch({
      type: GROUPS_FAIL,
      payload: { type: "added", message: error.message },
    });
    !stopAlert && failAlert("edited");
  }
};

// Get groups
export const getGroups = (user_id, token) => async (dispatch) => {
  try {
    dispatch({ type: GROUPS_START });
    const { data, status } = await axios.get(`/api/v1/groups`, {
      headers: {
        Authorization: token,
      },
    });
    if (status === 200) {
      dispatch({ type: GET_GROUPS_SUCCESS, payload: data.data.groups });
    }
  } catch (error) {
    dispatch({
      type: GROUPS_FAIL,
      payload: { type: "getGroups", message: error.message },
    });
  }
};

// Delete group
export const delGroup = (groupData, token) => async (dispatch) => {
  try {
    dispatch({ type: GROUPS_START });
    const { status } = await axios.delete(`/api/v1/groups/${groupData._id}`, {
      headers: {
        Authorization: token,
      },
    });
    if (status === 200) {
      dispatch({ type: GROUPS_DELETE_SUCCESS, payload: groupData });
      successAlert("deleted");
    }
  } catch (error) {
    failAlert("deleted");
    dispatch({ type: GROUPS_FAIL, payload: { type: "delGroup", message: error.message } });
  }
};

export const saveGroupFilter = (filter) => ({
  type: SAVE_GROUP_FILTER,
  filter,
});

// Set selected group
export const setSelectedGroup = (selectedGroup) => ({
  type: SELECTED_GROUP,
  selectedGroup,
});

// Set selected group
export const emptyGroups = () => ({
  type: EMPTY_GROUPS,
});
